<template>
  <div v-if="notFound" :class="componentClassName">
    <a-page-heading>企業情報管理 </a-page-heading>

    <m-section>
      <m-action-card id="settingsCompanyListTitle" :title="`企業情報 （${companyList.length}）`">
        <div class="t-setting-company-list__filters">
          <div class="t-setting-company-list__search">
            <a-select-field id="searchType" v-model="searchType" :options="searchTypeOptions" @change="handleChange" />
            <span class="t-setting-company-list__search-separator" />
            <a-text-field
              id="searchFilter"
              v-model="searchWord"
              type="search"
              placeholder="検索"
              maxlength="50"
              @keypress.enter.stop="handleSearchInput"
            />
          </div>
        </div>
        <template v-if="!readOnly" #action>
          <a-button
            id="addCompanyInfo"
            :inline="true"
            variant="fill"
            color="primary"
            size="small"
            icon="plus"
            label="企業情報追加"
            @click="handleCompanyAdd()"
          />
        </template>

        <m-data-table ref="dataTable" empty-text="登録がありません" :fit="true" :data="filterdCompanyList">
          <a-data-table-column prop="companyID" :filterable="true" :min-width="120" label="契約ID" align="left">
            <template #filter="scope">
              <m-filter-dialog
                v-if="scope"
                id="filter_companyID"
                variant="sort-normal"
                :handle-sort-ascending="() => handleSort('companyID', 'asc')"
                :handle-sort-descending="() => handleSort('companyID', 'desc')"
              />
            </template>
            <template #default="scope">
              {{ scope.row.companyID }}
            </template>
          </a-data-table-column>
          <a-data-table-column
            class="t-setting-company-list__wrap"
            prop="companyName"
            :filterable="true"
            :min-width="100"
            label="契約企業名"
            align="left"
          >
            <template #filter="scope">
              <m-filter-dialog
                v-if="scope"
                id="filter_companyName"
                variant="sort-normal"
                :handle-sort-ascending="() => handleSort('companyName', 'asc')"
                :handle-sort-descending="() => handleSort('companyName', 'desc')"
              />
            </template>
          </a-data-table-column>
          <a-data-table-column
            class="t-setting-company-list__wrap"
            prop="adminName"
            :filterable="true"
            :min-width="100"
            label="マスタ管理者名"
            align="left"
          >
            <template #filter="scope">
              <m-filter-dialog
                v-if="scope"
                id="filter_adminName"
                variant="sort-normal"
                :handle-sort-ascending="() => handleSort('adminName', 'asc')"
                :handle-sort-descending="() => handleSort('adminName', 'desc')"
              />
            </template>
          </a-data-table-column>
          <a-data-table-column
            class="t-setting-company-list__wrap"
            prop="adminEmail"
            :filterable="true"
            :min-width="100"
            label="メールアドレス"
            align="left"
          >
            <template #filter="scope">
              <m-filter-dialog
                v-if="scope"
                id="filter_adminEmail"
                variant="sort-normal"
                :handle-sort-ascending="() => handleSort('adminEmail', 'asc')"
                :handle-sort-descending="() => handleSort('adminEmail', 'desc')"
              />
            </template>
          </a-data-table-column>
          <a-data-table-column
            prop="targetService"
            :filterable="true"
            :min-width="100"
            label="対象サービス"
            align="left"
          >
            <template #filter="scope">
              <m-filter-dialog
                v-if="scope"
                id="filter_targetService"
                variant="sort-normal"
                :handle-sort-ascending="() => handleSort('targetService', 'asc')"
                :handle-sort-descending="() => handleSort('targetService', 'desc')"
              />
            </template>
          </a-data-table-column>
          <!-- <a-data-table-column prop="smsNumber" :width="120" label="SMS送信電話番号" align="left" /> -->
          <a-data-table-column prop="startDate" :filterable="true" :min-width="100" label="開通日" align="left">
            <template #filter="scope">
              <m-filter-dialog
                v-if="scope"
                id="filter_startDate"
                variant="sort-time"
                :handle-sort-ascending="() => handleSort('startDate', 'asc')"
                :handle-sort-descending="() => handleSort('startDate', 'desc')"
              />
            </template>
          </a-data-table-column>
          <a-data-table-column prop="closeDate" :filterable="true" :min-width="100" label="解約日" align="left">
            <template #filter="scope">
              <m-filter-dialog
                v-if="scope"
                id="filter_closeDate"
                variant="sort-time"
                :handle-sort-ascending="() => handleSort('closeDate', 'asc')"
                :handle-sort-descending="() => handleSort('closeDate', 'desc')"
              />
            </template>
          </a-data-table-column>
          <a-data-table-column
            prop="contractStatusName"
            :filterable="true"
            :min-width="100"
            label="契約ステータス"
            align="left"
          >
            <template #filter="scope">
              <m-filter-dialog
                v-if="scope"
                id="filter_contractStatusName"
                variant="sort-normal"
                :handle-sort-ascending="() => handleSort('contractStatusName', 'asc')"
                :handle-sort-descending="() => handleSort('contractStatusName', 'desc')"
              />
            </template>
          </a-data-table-column>
          <a-data-table-column type="action" :width="160" align="center" class="a-data-table-column--action">
            <template #default="scope">
              <a-button
                :id="'companyInfoEdit' + scope.index"
                variant="round"
                size="small"
                label="編集"
                color="grey"
                icon="edit"
                icon-color="black"
                :inline="true"
                @click="handleCompanyEdit(scope.row)"
              />
            </template>
          </a-data-table-column>
        </m-data-table>
      </m-action-card>
    </m-section>
  </div>

  <!-- Confirm, Error Modal -->
  <teleport to="body">
    <o-modal
      id="settingCompanyList_resultModal"
      v-model:visible="resultModalVisible"
      class="o-modal-remove-phone-number-confirmation"
      footer-variant="confirmation"
      width="442px"
      :footer-shadow="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
    >
      <template #title>{{ resultModalTitle }}</template>
      <a-text>
        <!-- eslint-disable -->
        <span v-html="resultModalContent" />
        <!-- eslint-enable -->
      </a-text>
      <template #footer>
        <a-button variant="block" color="primary" label="OK" size="small" @click="handleCloseModal" />
      </template>
    </o-modal>
  </teleport>
</template>

<script>
import { mapModifiers } from '@/libs/component';
import APageHeading from '@/components/atoms/page-heading';
import MActionCard from '@/components/molecules/action-card';
import AButton from '@/components/atoms/button';
import AText from '@/components/atoms/text';
import MSection from '@/components/molecules/section';
import MDataTable from '@/components/molecules/data-table';
import ADataTableColumn from '@/components/atoms/data-table-column';
import OModal from '@/components/organisms/modal';
import * as Handlebars from 'handlebars';

import { customRequest } from '@/common/customRequest.js';
import { messageContent } from '@/common/messageContent.js';
import { customValidate } from '@/common/customValidate.js';
import { POINT } from '@/libs/constants';

export default {
  name: 't-setting-company-list',
  components: {
    APageHeading,
    MSection,
    MActionCard,
    AButton,
    AText,
    MDataTable,
    ADataTableColumn,
    OModal,
  },
  mixins: [messageContent, customRequest, customValidate],
  props: {
    class: {
      type: String,
      default: '',
    },
    companyID: {
      type: String,
      default: '',
    },
    authInfo: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      selectedCompanyID: '',
      companyList: [],
      filterdCompanyList: [],
      resultModalVisible: false,
      resultModalTitle: '',
      resultModalContent: '',
      notFound: false,
      contractStatusList: {
        use: '利用中',
        suspend: '利用停止',
        close: '解約',
      },
      readOnly: false,
      searchTypeOptions: [
        {
          value: 'companyID',
          label: '契約ID',
        },
        {
          value: 'companyName',
          label: '契約企業名',
        },
        {
          value: 'adminName',
          label: 'マスタ管理者',
        },
        {
          value: 'adminEmail',
          label: 'メールアドレス',
        },
      ],
      searchType: 'companyID',
      searchWord: '',
    };
  },
  computed: {
    componentClassName() {
      const baseClassName = mapModifiers('t-setting-company-list');
      return `${baseClassName} ${this.class}`.trim();
    },
  },
  created() {
    if (this.companyID !== POINT) {
      this.$router.push({ path: '/permission-denied' });
    }

    if (this.authInfo === 'operator') {
      this.readOnly = true;
    }

    this.handlerFetchCompanyData();
  },
  methods: {
    handlerFetchCompanyData: function () {
      this.companyList = [];
      this.postRequest('/companymgmt/getinitdata')
        .then(e => {
          this.notFound = true;

          // トライアル対象を除外
          for (const tCompany of e.data) {
            if (!tCompany.companyID.match(/^tri/)) {
              this.companyList.push(tCompany);
            }
          }
          for (let i = 0; i < this.companyList.length; i++) {
            this.companyList[i].adminName = this.companyList[i].adminName
              ? this.companyList[i].adminName.replace('_', ' ')
              : this.companyList[i].adminName;
            this.companyList[i].targetService = this.companyList[i].voicedxOnlyFlag
              ? 'COTOHA Voice DX Basicのみ'
              : 'COTOHA Voice DX Basic・COTOHA Call Center共用';
            if (this.companyList[i].contractStatus !== '') {
              if (this.companyList[i].contractStatus in this.contractStatusList) {
                this.companyList[i].contractStatusName = this.contractStatusList[this.companyList[i].contractStatus];
              } else {
                this.companyList[i].contractStatusName = '';
              }
            } else {
              this.companyList[i].contractStatusName = '';
            }
          }
          // 表示用リストを更新
          this.setDisplayCompanyList();
        })
        .catch(err => {
          if (err === 404) this.$router.push({ path: '/permission-denied' });
          this.notFound = false;
        });
    },
    setDisplayCompanyList(searchType, searchWord) {
      if (typeof searchType === 'undefined' || typeof searchWord === 'undefined' || searchWord === '') {
        this.filterdCompanyList = this.companyList;
        return;
      }
      this.filterdCompanyList = this.companyList.filter(companyInfo => {
        if (typeof companyInfo[searchType] === 'undefined') {
          return false;
        }
        return companyInfo[searchType].indexOf(searchWord) !== -1;
      });
    },
    handleCompanyAdd() {
      this.$router.push({ path: '/companymgmt/add' });
    },
    handleCompanyEdit(row) {
      this.$router.push({ path: '/companymgmt/edit', query: { companyID: row.companyID } });
    },
    handleCloseModal() {
      this.resultModalVisible = false;
      this.resultModalTitle = '';
      this.resultModalContent = '';
    },
    showErrorModal(message) {
      this.resultModalVisible = true;
      this.resultModalTitle = messageContent.errorModalTitle;
      this.resultModalContent = message;
    },
    showInfoModal(message, selectedCompanyID) {
      this.resultModalVisible = true;
      this.resultModalTitle = messageContent.infoModalTitle;
      this.resultModalContent = message;
      this.companyList = this.companyList.filter(function (v) {
        return v.companyID !== selectedCompanyID;
      });
    },
    // 検索タイプを変更した時の処理
    handleChange() {
      this.searchWord = '';
    },
    // 検索実行時の処理
    handleSearchInput() {
      this.setDisplayCompanyList(this.searchType, this.searchWord);
    },
    getFilterColumnIndex(prop) {
      let columnIndex = -1;
      this.$refs.dataTable.columns.forEach((column, index) => {
        if (column.prop === prop) {
          columnIndex = index;
        }
      });
      return columnIndex;
    },
    handleFilterCancel(prop) {
      const columnIndex = this.getFilterColumnIndex(prop);
      if (columnIndex !== -1) {
        this.$refs.dataTable.$refs.tableHeader.hideFilter(columnIndex);
      }
    },
    // ソート時の処理
    handleSort(prop, dir) {
      const order = dir === 'asc' ? -1 : 1;
      this.filterdCompanyList.sort(function (a, b) {
        if (typeof a[prop] === 'undefined') return order;
        if (typeof b[prop] === 'undefined') return -order;
        if (a[prop] < b[prop]) return order;
        if (a[prop] > b[prop]) return -order;
        return 0;
      });
      this.handleFilterCancel(prop);
    },
  },
};
</script>
